import Garden6 from "../../Images/Garden6.webp";
import Garden2 from "../../Images/Garden2.webp";
import Garden1 from "../../Images/Garden1.jpeg";
import GarvanaHome from "../../Images/GarvanaHome.webp";
import "./Services.css";

export default function Services() {
    return (
      <section className="services-container">
        <h1 className="services-title">Our Services</h1>

        {/* Row 1 */}
        <div className="services-row">
          <div className="services-image">
            <img src={GarvanaHome} alt="Garden Landscaping Services" />
          </div>

          <div className="services-text">
            <h2>We Provide:</h2>
            <ul>
              <li>
                <strong>Landscape Designing:</strong> Professional landscape design services tailored for residential gardens, commercial spaces, and vertical gardens.
              </li>
              <li>
                <strong>Garden Maintenance:</strong> Seasonal pruning, fertilizing, pest control, and lawn care.
              </li>
              <li>
                <strong>Custom Garden Planning:</strong> Personalized planning based on soil, climate, sunlight, and client preferences.
              </li>
              <li>
                <strong>Indoor & Outdoor Plant Sales:</strong> Premium indoor & outdoor plants, exotic species, shrubs, flowers, and more.
              </li>
            </ul>
          </div>
        </div>

        {/* Row 2 */}
        <div className="services-row reverse">
          <div className="services-image">
            <img src={Garden1} alt="Expert Garden Maintenance" />
          </div>

          <div className="services-text">
            <h2>Additional Services:</h2>
            <ul>
              <li>
                <strong>Tree Planting & Care:</strong> Species selection, planting, and long-term growth monitoring.
              </li>
              <li>
                <strong>Organic Gardening Solutions:</strong> Organic fertilizers, pest control, composting, and chemical-free care.
              </li>
              <li>
                <strong>Garden Renovation & Remodeling:</strong> Transform old garden spaces into beautiful green zones.
              </li>
              <li>
                <strong>Customized Outdoor Spaces:</strong> Tailored landscaping for villas, resorts, terraces, and corporate spaces.
              </li>
            </ul>
          </div>
        </div>
      </section>
    );
}
